import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import EquipmentForm from "components/equipments/EquipmentForm";
import { updateEquipment, updateSpare } from "graphql/mutations";
import { getEquipment } from "graphql/queries";
import LoaderFullScreen from "components/utils/LoaderFullScreen";
import { convertToSlug } from "components/utils/functions";

const EquipmentUpdateForm = ({ equipmentId, onSuccess }) => {
  const navigate = useNavigate();
  const [equipment, setEquipment] = useState();
  const [loading, setLoading] = useState(false);

  async function onSubmit(valuesParam) {
    try {
      const {
        name,
        location,
        description,
        companyID,
        branchID,
        deviceID,
        routineID,
        equipmentTypeID,
        spares,
        coordsLat,
        coordsLng,
      } = valuesParam;

      setLoading(true);

      const promises = [];

      // Update spares
      const sparesToUnLink = equipment.spares?.filter(
        (servSpare) => !spares?.some((spare) => spare === servSpare)
      );
      sparesToUnLink?.forEach(async (spareId) => {
        promises.push(
          API.graphql({
            query: updateSpare.replaceAll("__typename", ""),
            variables: {
              input: {
                id: spareId,
                equipmentID: null,
              },
            },
          })
        );
      });
      const sparesToLink = spares?.filter(
        (spare) => !equipment.spares?.some((rec) => rec === spare)
      );
      sparesToLink?.forEach((spareId) => {
        promises.push(
          API.graphql({
            query: updateSpare.replaceAll("__typename", ""),
            variables: {
              input: {
                id: spareId,
                equipmentID: equipmentId,
              },
            },
          })
        );
      });

      await Promise.all(promises);

      await API.graphql({
        query: updateEquipment.replaceAll("__typename", ""),
        variables: {
          input: {
            id: equipmentId,
            name,
            slug: name && convertToSlug(name),
            location,
            description,
            companyID,
            branchID,
            deviceID,
            routineID,
            equipmentTypeID,
            coordsLat,
            coordsLng,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/equipments");
    } catch (err) {
      toast.error(strings.responses[err]);
    } finally {
      setLoading(false);
    }
  }

  async function fetchEquipment(id) {
    try {
      const equipmentData = await API.graphql(
        graphqlOperation(getEquipment, { id })
      );
      const equipmentItem = equipmentData.data.getEquipment;
      if (!equipmentItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/equipments");
        return;
      }
      setEquipment({
        ...equipmentItem,
        spares: equipmentItem.spares?.items?.map((t) => t.id) ?? [],
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchEquipment(equipmentId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipmentId]);

  if (!equipment) return <Loader />;

  return (
    <div>
      <EquipmentForm
        onSubmit={onSubmit}
        type="update"
        initialValues={equipment}
      />
      {loading && <LoaderFullScreen />}
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Equipo",
    successUpdated: "Equipo actualizado con éxito",
    responses: {
      errorFetch: "Error al consultar el equipo",
    },
  },
});

export default EquipmentUpdateForm;
